<template lang="pug">
.gym-card
  h5.gym-name
    | {{ gym.name }}
    Icon.featured-icon(v-if="gym.isFeatured" name="map/shield")
  .gym-type
    Icon(:name="gym.isFeatured ? 'map/pin-red' : 'map/pin'")
    | {{ __(gym.type) }}
  .gym-address(v-if="gym.address && gym.type !== 'Home Gym' &&gym.shareAddress") {{ __(gym.formattedAddress) }}
  .gym-phone(v-if="gym.phone") {{ __(gym.phone) }}
  RogueButton.details-button(color="black" @click="$emit('viewGymDetails', gym._id)")
    | {{ __('View Gym Details') }}
  a.mobile-details-link(href="#" @click="$emit('viewGymDetails', gym._id)")
    | {{ __('View Gym Details') }}
</template>
<script setup lang="ts">
import type { IGym } from '@rogue/universal'

defineProps<{
  gym: IGym
}>()

defineEmits<{ (e: 'viewGymDetails', gymId: string): void }>()

</script>
<style lang="scss" scoped>
.gym-card {
  background: $color-gray-x-light;
  border-bottom: 1px solid $color-gray;
  display: flex;
  flex-direction: column;
  gap: $space-xxs;
  padding: $space-s;

  .gym-name {
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: $size-s;
    gap: $space-xxs;
    line-height: $size-m;
    margin: 0;

    .featured-icon {
      height: $size-s;
      width: $size-xs;
    }
  }

  .gym-type {
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: $size-xxs;
    font-weight: bold;
    gap: $space-xxxs;

    .icon {
      height: $size-s;
      width: $size-xs;
    }
  }

  .gym-address,
  .gym-phone {
    font-size: $size-xs;
    line-height: $size-m;
  }

  .details-button {
    margin-top: $spacing-xl;

    @include not-desktop() {
      display: none;
    }
  }

  .mobile-details-link {
    color: $color-black;
    display: none;
    font-size: $size-xs;
    line-height: $size-xs;
    text-decoration: underline;

    @include not-desktop() {
      display: block;
    }
  }
}
</style>
